import { formatDateFR } from '../../shared/utils/helpers';
import html2pdf from 'html2pdf.js';
import { escapeForHtml } from '../../shared/utils/escapeHtml';

export function printMokhalafaNarsa(mRaw, settingsRaw, action = 'print') {
  // XSS: escape all contravention/agency data before HTML interpolation.
  const m = escapeForHtml(mRaw || {});
  const settings = escapeForHtml(settingsRaw || {});
  // Helper: render boxes for character-by-character input
  const charBoxes = (value, count) => {
    const chars = (value || '').toString().split('').slice(0, count);
    let html = '';
    for (let i = 0; i < count; i++) {
      html += `<span class="char-box">${chars[i] || ''}</span>`;
    }
    return html;
  };
  
  const formatDate = (d) => formatDateFR(d) || '';
  
  const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>Déclaration NARSA - ${m.clientName || ''}</title>
<style>
@page { size: A4 portrait; margin: 8mm; }
* { box-sizing: border-box; }
body { margin: 0; padding: 0; font-family: 'Arial', sans-serif; color: #000; font-size: 10px; line-height: 1.3; }

/* Header */
.header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; padding-bottom: 6px; }
.header .logo-left { width: 90px; }
.header .logo-left img { max-width: 90px; max-height: 40px; }
.header .narsa-logo { font-size: 9px; font-weight: bold; text-align: left; color: #1e40af; line-height: 1.1; }
.header .narsa-logo .name { font-size: 11px; }
.header .ar-name { direction: rtl; font-size: 8px; color: #444; }
.header .title { text-align: center; flex: 1; }
.header .title .fr { font-size: 14px; font-weight: bold; margin-top: 2px; }
.header .title .ar { font-size: 13px; font-weight: bold; direction: rtl; }
.header .logo-right { width: 60px; }

.ref-line { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; font-size: 9px; }
.ref-line .ref-label { background: #d6e6f5; padding: 4px 10px; border-radius: 2px; font-weight: bold; }
.ref-line .ref-value { background: #fff; border: 1px solid #999; padding: 4px 10px; min-width: 80px; }

/* Avis line */
.avis-row { display: flex; align-items: center; padding: 4px 0; border-bottom: 1px solid #aaa; gap: 4px; font-size: 9px; }
.avis-row .label-fr { flex: 1; }
.avis-row .label-ar { flex: 1; text-align: right; direction: rtl; }
.avis-row .boxes { display: flex; gap: 1px; }

.char-box { display: inline-block; width: 16px; height: 16px; border: 1px solid #333; text-align: center; line-height: 16px; font-size: 11px; font-weight: bold; }
.rf-box { display: inline-block; padding: 0 4px; height: 16px; border: 1px solid #333; line-height: 16px; font-size: 10px; font-weight: bold; background: #f0f0f0; min-width: 24px; text-align: center; }

/* "Je soussigné" section */
.subscribe { padding: 6px 0; font-size: 8.5px; line-height: 1.4; }
.subscribe-row { display: flex; gap: 8px; }
.subscribe-fr { flex: 1; }
.subscribe-ar { flex: 1; direction: rtl; text-align: right; }
.subscribe ul { margin: 2px 0 0 14px; padding: 0; }
.subscribe li { margin-bottom: 1px; }

/* Form rows */
.form-row { display: flex; border-bottom: 1px solid #999; min-height: 22px; align-items: stretch; }
.form-row .fr-label { width: 26%; padding: 4px 6px; background: #fff; font-size: 9px; border-right: 1px solid #999; display: flex; align-items: center; }
.form-row .input-area { flex: 1; padding: 4px 8px; display: flex; align-items: center; font-family: 'Courier New', monospace; font-size: 10px; font-weight: bold; min-height: 22px; }
.form-row .ar-label { width: 26%; padding: 4px 6px; font-size: 9px; direction: rtl; text-align: right; border-left: 1px solid #999; display: flex; align-items: center; justify-content: flex-end; }

/* Section title bar */
.section-bar { background: #cfd9e8; padding: 4px 8px; font-size: 10px; font-weight: bold; border-top: 2px solid #4a6fa5; border-bottom: 1px solid #4a6fa5; display: flex; justify-content: space-between; }
.section-bar .ar { direction: rtl; }

/* Declaration paragraph */
.declaration { padding: 6px 0; font-size: 9px; line-height: 1.5; border-bottom: 1px solid #999; }
.declaration .row { display: flex; gap: 12px; align-items: center; }
.declaration .row .fr { flex: 1; }
.declaration .row .ar { flex: 1; direction: rtl; text-align: right; }
.plate-boxes { display: inline-flex; gap: 1px; margin: 0 4px; }

/* Signature & footer */
.sig-section { display: flex; gap: 8px; margin-top: 6px; }
.sig-left { flex: 1; padding: 6px; font-size: 8.5px; line-height: 1.4; }
.sig-right { flex: 1; border: 1px solid #999; padding: 8px; text-align: center; min-height: 100px; }
.sig-right .label-fr { font-size: 9px; font-weight: bold; margin-bottom: 4px; }
.sig-right .label-ar { direction: rtl; font-size: 9px; font-weight: bold; margin-bottom: 8px; }
.sig-right img { max-width: 100%; max-height: 60px; }

.signature-bottom { display: flex; gap: 4px; margin-top: 6px; padding: 6px; border: 1px solid #999; align-items: center; min-height: 50px; }
.signature-bottom .left { flex: 1; font-size: 8.5px; }
.signature-bottom .right { flex: 1; text-align: center; }
.signature-bottom .right img { max-height: 50px; }

.footer-note { margin-top: 8px; padding: 4px; border-top: 1px solid #999; font-size: 8px; text-align: center; font-style: italic; }

/* Fait à row */
.fait-row { display: flex; gap: 12px; padding: 6px 0; font-size: 9px; border-bottom: 1px solid #999; align-items: center; }
.fait-row .item { display: flex; gap: 4px; align-items: center; }
.fait-row .item .v { background: #fff; border-bottom: 1px solid #333; padding: 0 6px; min-width: 80px; font-family: monospace; font-weight: bold; }

.print-bar { background: #1e293b; color: white; padding: 12px; text-align: center; }
.print-bar button { background: #10b981; color: white; padding: 10px 24px; border: none; border-radius: 6px; font-weight: 700; cursor: pointer; font-size: 14px; }

@media print {
  .no-print { display: none !important; }
  body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
</head>
<body>
<div class="no-print print-bar">
  <button onclick="window.print()">🖨️ Imprimer / طباعة</button>
</div>

<!-- HEADER WITH NARSA -->
<div class="header">
  <div class="logo-left">
    <div class="narsa-logo">
      <div class="name">NARSA</div>
      <div style="font-size: 7px; color: #666;">الوكالة الوطنية للسلامة الطرقية</div>
      <div style="font-size: 7px; color: #666;">NATIONAL ROAD SAFETY AGENCY</div>
    </div>
  </div>
  <div class="title">
    <div class="ar">التصريح بمرتكب المخالفة</div>
    <div class="fr">Déclaration de l'auteur de l'infraction</div>
  </div>
  <div class="logo-right"></div>
</div>

<!-- Ref -->
<div class="ref-line">
  <div class="ref-label">Réf. : DEC</div>
</div>

<!-- N° avis with boxes -->
<div class="avis-row">
  <div class="label-fr">
    N° de l'avis de contravention<br>
    <span style="font-style: italic; font-size: 8px;">(Copie à joindre au présent formulaire)</span>
  </div>
  <div class="boxes">
    ${charBoxes(m.avisNumber, 7)}
    <span class="rf-box">R F</span>
    ${charBoxes(m.avisRF, 5)}
  </div>
  <div class="label-ar">
    رقم الإشعار بالمخالفة<br>
    <span style="font-style: italic; font-size: 8px;">(إرفاق نسخة من الإشعار بهذا المطبوع)</span>
  </div>
</div>

<!-- "Je soussigné" -->
<div class="subscribe">
  <div class="subscribe-row">
    <div class="subscribe-fr">
      <strong>Je soussigné(e):</strong>
      <ul>
        <li>Personne physique</li>
        <li>Représentant légal de la personne morale ou de l'agence de location de voitures sans chauffeur en particulier</li>
        <li>Personne habilitée en cas des administrations publiques, aux établissements et entreprise publics et aux collectivités locales</li>
      </ul>
    </div>
    <div class="subscribe-ar">
      <strong>أنا الممضي(ة) أسفله:</strong>
      <ul style="list-style-position: inside;">
        <li>شخص ذاتي</li>
        <li>الممثل القانوني في حالة الأشخاص المعنويين عامة أو وكالات كراء السيارات بدون سائق على وجه الخصوص</li>
        <li>شخص له الصلاحية القانونية إذا تعلق الأمر بالإدارات العمومية، بالمؤسسات والشركات العمومية والجماعات المحلية</li>
      </ul>
    </div>
  </div>
</div>

<!-- DECLARANT INFO -->
<div class="form-row">
  <div class="fr-label">Nom</div>
  <div class="input-area">${m.declarantNom || ''}</div>
  <div class="ar-label">الاسم العائلي</div>
</div>
<div class="form-row">
  <div class="fr-label">Prénom (s)</div>
  <div class="input-area">${m.declarantPrenom || ''}</div>
  <div class="ar-label">الاسم الشخصي</div>
</div>
<div class="form-row">
  <div class="fr-label">Fonction</div>
  <div class="input-area">${m.declarantFonction || ''}</div>
  <div class="ar-label">المهنة</div>
</div>
<div class="form-row">
  <div class="fr-label">N° de GSM</div>
  <div class="input-area">${m.declarantGsm || ''}</div>
  <div class="ar-label">رقم الهاتف النقال</div>
</div>
<div class="form-row">
  <div class="fr-label">Adresse mail</div>
  <div class="input-area">${m.declarantEmail || ''}</div>
  <div class="ar-label">عنوان البريد الإلكتروني</div>
</div>
<div class="form-row">
  <div class="fr-label">Raison sociale</div>
  <div class="input-area">${m.declarantRaisonSociale || ''}</div>
  <div class="ar-label">اسم الشركة أو الإدارة</div>
</div>
<div class="form-row">
  <div class="fr-label">Adresse</div>
  <div class="input-area">${m.declarantAdresse || ''}</div>
  <div class="ar-label">العنوان</div>
</div>
<div class="form-row" style="min-height: 28px;">
  <div class="fr-label">Ville</div>
  <div class="input-area" style="flex: 0.6;">${m.declarantVille || ''}</div>
  <div class="fr-label" style="background:#f7f7f7; border-left: 1px solid #999; width: auto; padding: 4px 6px;">Code postal</div>
  <div class="input-area" style="flex: 0.4; font-family: monospace;">${m.declarantCodePostal || ''}</div>
  <div class="ar-label">الرمز البريدي &nbsp; المدينة</div>
</div>

<!-- Vehicle declaration -->
<div class="declaration">
  <div class="row">
    <div class="fr">
      <strong>Déclare que le véhicule, immatriculé sous le numéro</strong>
      <div class="plate-boxes">
        ${(m.carPlate || '').split('').slice(0, 12).map(c => `<span class="char-box">${c}</span>`).join('')}
      </div>
      <br>
      objet de l'avis de contravention sus indiqué :<br>
      était conduit, au moment de la constatation de l'infraction par :
    </div>
    <div class="ar">
      <strong>أصرح أن المركبة المسجلة تحت رقم</strong><br>
      موضوع الإشعار بالمخالفة المشار إليها<br>
      أعلاه، كانت مساقة وقت معاينة المخالفة من طرف :
    </div>
  </div>
</div>

<!-- PERSONNE PHYSIQUE Section -->
<div class="section-bar">
  <span>Personne physique</span>
  <span class="ar">شخص ذاتي</span>
</div>
<div class="form-row">
  <div class="fr-label">Nom</div>
  <div class="input-area">${m.clientName || ''}</div>
  <div class="ar-label">الاسم العائلي</div>
</div>
<div class="form-row">
  <div class="fr-label">Prénom (s)</div>
  <div class="input-area">${m.clientFirstName || ''}</div>
  <div class="ar-label">الاسم الشخصي</div>
</div>
<div class="form-row">
  <div class="fr-label">Adresse</div>
  <div class="input-area">${m.clientAddress || ''}</div>
  <div class="ar-label">العنوان</div>
</div>
<div class="form-row" style="min-height: 28px;">
  <div class="fr-label">Ville</div>
  <div class="input-area" style="flex: 0.6;">${m.clientCity || ''}</div>
  <div class="fr-label" style="background:#f7f7f7; border-left: 1px solid #999; width: auto; padding: 4px 6px;">Code postal</div>
  <div class="input-area" style="flex: 0.4; font-family: monospace;">${m.clientPostalCode || ''}</div>
  <div class="ar-label">الرمز البريدي &nbsp; المدينة</div>
</div>
<div class="form-row">
  <div class="fr-label">
    N° de la C.N.I.E ou de la carte<br>
    séjour <span style="font-style: italic;">(joindre une copie)</span>
  </div>
  <div class="input-area">
    <div style="display: flex; gap: 1px;">
      ${(m.clientCin || '').split('').slice(0, 10).map(c => `<span class="char-box">${c}</span>`).join('')}
    </div>
  </div>
  <div class="ar-label">
    رقم البطاقة الوطنية للتعريف الإلكترونية أو بطاقة<br>
    الإقامة (إرفاق نسخة)
  </div>
</div>
<div class="form-row">
  <div class="fr-label">
    N° de permis de conduire <span style="font-style: italic;">(joindre une copie)</span>
  </div>
  <div class="input-area">${m.clientPermis || ''}</div>
  <div class="ar-label">رقم رخصة السياقة (إرفاق نسخة)</div>
</div>

<!-- PERSONNE MORALE Section (empty by default) -->
<div class="section-bar">
  <div>
    <strong>Personne morale</strong><br>
    <span style="font-size: 8px; font-weight: normal;">Réservé aux agences de location de voitures sans chauffeur</span><br>
    <span style="font-size: 8px; font-weight: normal; font-style: italic;">En cas de location à une personne morale)</span>
  </div>
  <div class="ar">
    <strong>شخص معنوي</strong><br>
    <span style="font-size: 8px; font-weight: normal;">خاص بوكالات كراء السيارات بدون سائق في حالة الكراء لشخص معنوي</span>
  </div>
</div>
<div class="form-row">
  <div class="fr-label">Raison sociale</div>
  <div class="input-area">${m.moraleRaisonSociale || ''}</div>
  <div class="ar-label">: اسم الشركة</div>
</div>
<div class="form-row">
  <div class="fr-label">Adresse</div>
  <div class="input-area">${m.moraleAdresse || ''}</div>
  <div class="ar-label">العنوان</div>
</div>
<div class="form-row" style="min-height: 28px;">
  <div class="fr-label">Ville</div>
  <div class="input-area" style="flex: 0.6;">${m.moraleVille || ''}</div>
  <div class="fr-label" style="background:#f7f7f7; border-left: 1px solid #999; width: auto; padding: 4px 6px;">Code postal</div>
  <div class="input-area" style="flex: 0.4; font-family: monospace;">${m.moralePostalCode || ''}</div>
  <div class="ar-label">الرمز البريدي &nbsp; المدينة</div>
</div>

<!-- Fait à / Le -->
<div class="fait-row">
  <div class="item">
    <strong>Fait à :</strong>
    <div class="v">${m.fait_a || ''}</div>
  </div>
  <div class="item">
    <strong>Le :</strong>
    <div class="v">${formatDate(m.le_date)}</div>
  </div>
  <div class="item" style="margin-left: auto;">
    <strong>: في</strong>
    <div class="v">${formatDate(m.le_date)}</div>
  </div>
  <div class="item">
    <strong>: حرر ب</strong>
    <div class="v">${m.fait_a || ''}</div>
  </div>
</div>

<!-- Signatures (declarant) -->
<div class="signature-bottom">
  <div class="left">
    <strong>Signature de la personne physique déclarant ou signature et cachet de la personne morale ou l'Administration</strong>
    <div style="direction: rtl; text-align: right; margin-top: 4px;">
      <strong>إمضاء الشخص الذاتي المصرح أو إمضاء وخاتم الشخص المعنوي أو الإدارة</strong>
    </div>
  </div>
  <div class="right">
    ${settings.companyStamp 
      ? `<img src="${settings.companyStamp}" crossorigin="anonymous" alt="Cachet">` 
      : '<div style="height: 50px;"></div>'}
  </div>
</div>

<!-- Signature du déclaré (client) -->
<div class="signature-bottom" style="margin-top: 4px;">
  <div class="left">
    <strong>Signature du déclaré</strong>
    <div style="font-style: italic; font-size: 8px;">(En cas de déclaration d'une personne physique)</div>
    <div style="direction: rtl; text-align: right; margin-top: 4px;">
      <strong>إمضاء المصرح به</strong>
      <div style="font-style: italic; font-size: 8px;">(في حالة تصريح الأشخاص الذاتيين)</div>
    </div>
  </div>
  <div class="right">
    ${m.clientSignature 
      ? `<img src="${m.clientSignature}" crossorigin="anonymous" alt="Signature">` 
      : '<div style="height: 50px;"></div>'}
  </div>
</div>

<!-- Instructions box (right side info, like in PDF) -->
<div style="margin-top: 8px; padding: 6px; background: #f5f5f5; border: 1px solid #999; font-size: 8.5px; line-height: 1.4;">
  <div style="display: flex; gap: 8px;">
    <div style="flex: 1;">
      Ce formulaire, dûment renseigné et signé, assorti d'une copie de l'avis de contravention objet de la déclaration et des justificatifs associés, doit être déposé, dans un délai de <strong>30 jours</strong> à compter de la date de notification de l'avis de contravention, auprès des services extérieurs de l'Agence Nationale de la Sécurité Routière. Le dépôt peut être effectué par le déclarant, le contrevenant, ou une personne mandatée par le déclarant.
    </div>
    <div style="flex: 1; direction: rtl; text-align: right;">
      يجب تعبئة النموذج بدقة وتوقيعه وإرفاقه بنسخة من الإشعار بالمخالفة موضوع التصريح وكذا بالوثائق المبررة وإيداعه مباشرة، داخل أجل <strong>30 يوما</strong> إبتداء من تاريخ الإشعار بالمخالفة، بإحدى المصالح الخارجية للوكالة الوطنية للسلامة الطرقية. يمكن أن يتم الإيداع من طرف المصرح أو المخالف أو أي شخص يتم توكيله من طرف المصرح.
    </div>
  </div>
</div>

<!-- Footer warning -->
<div class="footer-note">
  <div style="direction: rtl;">ملحوظة : كل من أدلى بمعلومات غير صحيحة أو بوثائق مزيفة أو ساعد على ذلك سيعاقب طبقا للقوانين الجاري بها العمل.</div>
  <div><strong>NB :</strong> Toute personne ayant fourni de faux renseignements ou documents falsifiés ou ayant aidé pour le faire sera puni conformément aux lois en vigueur.</div>
</div>

</body>
</html>`;
  
  if (action === 'get_pdf_blob') {
    const element = document.createElement('div');
    element.innerHTML = html;
    element.style.position = 'fixed';
    element.style.left = '0';
    element.style.top = '0';
    element.style.zIndex = '-99999';
    element.style.width = '210mm';
    document.body.appendChild(element);

    const opt = {
      margin:       5,
      filename:     `Contravention_NARSA_${(m.clientName || 'Client').replace(/\s+/g, '_')}_${m.avisNumber || 'Avis'}.pdf`,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2, useCORS: true, logging: false, scrollY: 0, scrollX: 0 },
      jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    return new Promise((resolve, reject) => {
      html2pdf().set(opt).from(element).output('blob').then(blob => {
        document.body.removeChild(element);
        resolve(blob);
      }).catch(err => {
        if (element.parentNode) document.body.removeChild(element);
        reject(err);
      });
    });
  }

  const win = window.open('', '_blank', 'width=900,height=900');
  if (!win) return alert('⚠️ Bloqué. Autorisez les pop-ups.');
  win.document.write(html);
  win.document.close();
}
